module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M2 0C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h2V0H2zm24 0H6v32h20c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-5 18h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6h-8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/journal-2.js
// module id = 1198
// module chunks = 14